<template>
  <Content
    :title="$t('SETTINGS.DEVELOPERS_API.TITLE')"
    :description="$t('SETTINGS.DEVELOPERS_API.DESC')"
    :hint="$t('HINTS.SETTING.DEVELOPERS_API')"
  >
    <ElButton
      type="primary"
      icon="el-icon-plus"
      @click.native.prevent="openModal('newClientModalShow')"
    >
      {{ $t('SETTINGS.DEVELOPERS_API.NEW_CLIENT_BTN') }}
    </ElButton>

    <CardApiError
      v-if="apiError"
      :error-text="$t('SETTINGS.DEVELOPERS_API.API_ERROR')"
      @retry="getClients"
    />

    <div v-else-if="clients.length" class="table-responsive raised">
      <table dir="ltr" class="table table--padded table--hover text-latin">
        <thead>
          <tr>
            <th>{{ $t('SETTINGS.DEVELOPERS_API.CLIENT_ID') }}</th>
            <th>{{ $t('SETTINGS.DEVELOPERS_API.CLIENT_SECRET') }}</th>
            <th>{{ $t('SETTINGS.DEVELOPERS_API.CLIENT_URI') }}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="client in clients" :key="client.id">
            <td class="text-break">
              {{ client.client_id }}
            </td>
            <td class="text-break">
              {{ client.client_secret }}
            </td>
            <td class="text-break">
              {{ client.redirect_uris }}
            </td>
            <td class="text-end">
              <ElButton
                type="danger"
                icon="el-icon-delete"
                size="small"
                @click.native.prevent="deleteClient(client)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="card">
      <div
        v-show="isLoadingClients"
        class="card__block card__block--loading"
        dir="ltr"
      >
        <HollowDotsSpinner
          :animation-duration="1000"
          :dot-size="12"
          :dots-num="3"
          :color="'#95a5a6'"
        />
      </div>
      <div v-show="!isLoadingClients" class="card__block">
        {{ $t('SETTINGS.DEVELOPERS_API.NO_DATA') }}
      </div>
    </div>
    <AddClientModal v-model="newClientModalShow" @client-add="addClient" />
  </Content>
</template>

<script>
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';
import Content from '@@/common/layout/Content';

import { Clients } from '@/api/api';
import modal from '@/mixins/modal';
import form from '@/mixins/form';
import layout from '@/mixins/layout';

import CardApiError from '@@/common/CardApiError';
import AddClientModal from './modal/AddClientModal';

export default {
  name: 'DevelopersAPISettings',

  components: {
    Content,
    HollowDotsSpinner,
    CardApiError,
    AddClientModal,
  },

  mixins: [modal, form, layout],

  data() {
    return {
      clients: [],
      newClientModalShow: false,
      apiError: false,
      isLoadingClients: true,
    };
  },

  created() {
    this.setPageTitle('SETTINGS');

    this.getClients();
    // initialize an empty client
  },

  methods: {
    addClient(client) {
      this.clients.push(client);
    },
    deleteClient(client) {
      this.$confirm(this.$t('DELETE_ITEM_WARNING'), this.$t('WARNING'), {
        confirmButtonText: this.$t('DELETE_IT'),
        cancelButtonText: this.$t('CANCEL'),
        cancelButtonClass: 'el-button--text is-plain',
        type: 'warning',
      })
        .then(() => {
          Clients.delete({
            id: client.client_id,
          })
            .then(() => {
              this.$message.success(this.$t('DELETE_COMPLETED'));
            })
            .then(() => {
              this.clients.splice(this.clients.indexOf(client), 1);
            })
            .catch(({ body: { message } = {} }) => {
              if (message) {
                this.$message.error(message);
              }
            });
        })
        .catch(() => {});
    },

    getClients() {
      this.isLoadingClients = true;
      this.apiError = false;

      Clients.get()
        .then(({ body: { clients = [] } }) => {
          this.isLoadingClients = false;
          this.clients = clients;
        })
        .catch(({ body: { message } = {} }) => {
          this.isLoadingClients = false;

          if (message) {
            this.$message.error(message);
          }

          this.apiError = true;
        });
    },
  },
};
</script>
